import { combineReducers } from 'redux'
import cart from 'store/cart/reducers'
import paypal from 'store/paypal/reducers'

export default combineReducers({ cart, paypal })
